/* eslint-disable no-console */

import chalk from 'chalk';

import { getTimestampNow } from './dateTime';
import { isDevOrLocalEnvironment } from './url';

const prefix = (severity: 'log' | 'error' | 'warn') => {
  const text = `[DEV]${chalk.gray(`[${getTimestampNow()}]`)}`;

  switch (severity) {
    case 'log':
      return chalk.cyan(text);
    case 'error':
      return chalk.red(text);
    case 'warn':
      return chalk.yellow(text);
  }
};

export const bufferingLog = (...args: any[]) =>
  isDevOrLocalEnvironment &&
  console.log(
    `${prefix('log')}${chalk.bgRgb(142, 69, 133).white(' SignalR Buffering ')}`,
    ...args
  );

export const wakeLockLog = (...args: any[]) =>
  isDevOrLocalEnvironment &&
  console.log(`${prefix('log')}${chalk.bgGray.white(' WakeLock ')}`, ...args);

export const devLog = (...args: any[]) =>
  isDevOrLocalEnvironment && console.log(prefix('log'), ...args);

export const devError = (...args: any[]) =>
  isDevOrLocalEnvironment && console.error(prefix('error'), ...args);

export const devWarn = (...args: any[]) =>
  isDevOrLocalEnvironment && console.warn(prefix('warn'), ...args);

// Production logging functions
const productionPrefix = (severity: string) => {
  const text = `${chalk.gray(`[${getTimestampNow()}]`)}`;

  switch (severity) {
    case 'success':
      return `${chalk.green('[SUCCESS]')} ${text} `;
    case 'info':
      return `${chalk.cyan('[INFO]')} ${text} `;
    case 'warn':
      return `${chalk.yellow('[WARN]')} ${text} `;
    case 'error':
      return `${chalk.red('[ERROR]')} ${text} `;
  }
};

export const logInfo = (...args: any[]) =>
  console.log(productionPrefix('info'), ...args);

export const logSuccess = (...args: any[]) =>
  console.log(productionPrefix('success'), ...args);

export const logWarn = (...args: any[]) =>
  console.warn(productionPrefix('warn'), ...args);

export const logError = (...args: any[]) =>
  console.error(productionPrefix('error'), ...args);
